module.exports = __webpack_public_path__ + "img/img28.2404a60b.jpg";